import { FormDataType } from '../../../../types/Forms/formTypes'

export const FormVersion = '1.2'
export default FormVersion

export const isSupported = (form?: FormDataType | null) => form?.template.__version === FormVersion
